import React from "react";

import {Button, Card, Col, Input, InputNumber, Modal, Popconfirm, Row, Typography} from "antd";

import {
    ArrowLeftOutlined,
    ArrowRightOutlined,
    CopyOutlined,
    DeleteOutlined,
    FormOutlined,
    PlusOutlined
} from "@ant-design/icons"
import ApiService from "../../services/ApiService";
import moment from "moment";
import {APP_PREFIX_PATH, ASSET_BASE_URL} from "../../configs/AppConfig";

const {Text} = Typography

export default class EmailTemplateField extends React.Component {

    state = {
        data: [],
        selected: null,
        visible: false
    }

    init(){
        this.getData()
        if (this.props.value) {
            this.getSelected()
        }
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value != this.props.value) {
            this.getSelected()
        }
    }

    async getSelected() {
        var res = await ApiService.get("/email_templates/id/" + this.props.value)
        this.setState({selected: res.data})
    }

    async getData() {
        this.setState({loading: true});
        var res = await ApiService.get("/email_templates")
        console.log(res)

        this.setState({
            data: res.data,
        });
    };

    render() {
        const {value, onChange, editable} = this.props

        if (editable === false && !value) {
            return null
        }

        if (editable === false && value) {
            return <CardTemplate item={this.state.selected} mini/>
        }

        return (
            <div>
                {!value && (
                    <Button type="dashed" onClick={() => {
                        this.init()
                        this.setState({visible: true})
                    }}>Choisir un Modèle</Button>
                )}


                {value && this.state.selected && (
                    <CardTemplate item={this.state.selected} mini closable onSelect={() => onChange(null)}/>
                )}

                <Modal title={"Choisir un Modèle d'email"} width="100%" open={this.state.visible} footer={false}
                       closable onCancel={() => this.setState({visible: false})}>
                    <Row style={{gap: 30}}>

                        <Card
                            style={{width: 300, position: "relative"}}
                            hoverable
                            cover={(
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: 300
                                }}><PlusOutlined style={{fontSize:100}}/></div>
                            )}
                            onClick={()=>window.open(APP_PREFIX_PATH+"/templates/email",'_blank')}
                        >
                            <Card.Meta
                                title={"Créer un nouveau modèle"}
                            />
                        </Card>

                        {this.state.data.map((item) => <CardTemplate item={item} onSelect={() => {
                            onChange(item.id)
                            this.setState({visible: false})
                        }}/>)}
                    </Row>
                </Modal>
            </div>
        )

    }
}


function CardTemplate({item, onSelect = null, onDeselect = null, mini = false, closable = false}) {
    var width = 300
    var height = 300
    if (mini) {
        width = 200
        height = 100
    }

    if (!item) {
        return null
    }

    var cover = (<div style={{display: "flex", justifyContent: "center", alignItems: "center", height: height}}><img
        src={"/img/template-email-default.png"} style={{height: 96, width: 96}}/></div>)

    if (item.image) {
        cover = (<img src={ASSET_BASE_URL + "/" + item.image}
                      style={{height: height, width: width, objectFit: "cover", objectPosition: "top"}}/>)
    }

    return (
        <Col key={item.id}>

            <Card
                style={{width: width, position: "relative"}}
                cover={cover}
                hoverable
                onClick={onSelect}
            >
                {closable === true && (
                    <div style={{position: "absolute", top: 0, right: 0}}>
                        <Button danger type="primary" icon={<DeleteOutlined/>} onClick={onDeselect}/>
                    </div>
                )}

                <Card.Meta
                    title={item.name}
                    description={mini ? null :
                        <Text>Créer le {moment(item.datetime).format("dddd DD MMMM YYYY")}</Text>}
                />
            </Card>

        </Col>
    )
}
